export default function ModelS() {
  return (
    <div
      className="ion-icon-model-s"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path d="M508.8,390.9c-0.6,4.1-1.6,8.1-3.1,11.2c-2.7,5.5-5.3,6-15.5,5.5c-13.2-0.6-32.1,0-52.1,0.8c0,5.5,0.2,8.1,0.2,8.1
		c1.3,15.1,8.1,15.6,10.8,15.6c3,0,39.2,0,43,0s7.3,0,10-1.8c3.5-2.3,5-9,6.3-20.7c0.2-1.7,0.3-3.9,0.4-6.5c0,0,0-0.1,0-0.1
		c0-0.8,0.1-1.8,0.1-2.9c0-0.4,0-0.8,0-1.1c0,0,0,0,0,0C508.9,396.3,508.9,393.3,508.8,390.9z"/>
	<path d="M3,390.9c0.6,4.1,1.6,8.1,3.1,11.2c2.7,5.5,5.3,6,15.5,5.5c13.2-0.6,32.1,0,52.1,0.8c0,5.5-0.2,8.1-0.2,8.1
		c-1.3,15.1-8.1,15.6-10.8,15.6c-3,0-39.2,0-43,0s-7,0-10-1.8c-3.6-2.1-5-9-6.3-20.7c-0.2-1.7-0.3-3.9-0.4-6.5c0,0,0-0.1,0-0.1
		c0-0.8-0.1-1.8-0.1-2.9c0-0.4,0-0.8,0-1.1c0,0,0,0,0,0C3,396.3,3,393.3,3,390.9z"/>
	<path d="M512,296.6c0-30.7-4-60.7-5.6-64c-1.2-2.4-8.9-8.7-26.4-20.6c-17.7-12.1-17.3-10.3-20.5-18.2c2.9-0.9,5.7-2.6,7.4-2.8
		c3.8-0.4,4,3.2,11.9,3.2s25-2.1,28.5-5.6c3.5-3.5,4.6-4.7,4.6-7.8s-1.8-9.5-5.2-13.3s-17.9-5.7-26.4-6.8s-9.7,0-11.9,1.4
		c-3.5,2.2-3.7,22.3-3.7,22.3l-8.3,0.2c-5.4-13.3-12.9-40.1-24.6-61.2c-12.8-23-26.2-30.2-31.8-32c-5.5-1.7-10.5-2.9-48-6.7
		c-38.3-4-68.8-4.5-96-4.5s-57.7,0.6-96,4.5c-37.5,3.9-42.5,5-48,6.7c-5.5,1.7-19,9-31.8,32c-11.7,21.1-19.2,47.9-24.6,61.2
		l-8.3-0.2c0,0-0.1-20.1-3.7-22.3c-2.2-1.4-3.4-2.6-11.9-1.4s-23,3-26.4,6.8s-5.2,10.2-5.2,13.3s1.1,4.4,4.6,7.8
		c3.5,3.5,20.6,5.6,28.5,5.6s8.1-3.6,11.9-3.2c1.7,0.2,4.6,1.9,7.4,2.8c-3.3,7.9-2.8,6.1-20.5,18.2c-17.5,12-25.3,18.2-26.4,20.6
		C4,235.9,0,265.9,0,296.6s2.2,58.3,2.2,68.1c0,4.1,0,11.3,0.9,18.2c0.6,4.1,1.5,8.1,3.1,11.2c2.7,5.5,5.2,6,15.5,5.5
		c13.2-0.6,32.3,0,52,0.8c13.2,0.5,26.7,1,38.7,1.3c30,0.6,21.2-4.4,34-4.2c12.8,0.2,63.3,2.3,109.5,2.3s96.8-2.1,109.5-2.3
		c12.8-0.2,4,4.8,34,4.2c12-0.2,25.5-0.8,38.7-1.3c19.7-0.7,38.9-1.4,52-0.8c10.3,0.5,12.8,0,15.5-5.5c1.5-3.1,2.5-7.1,3.1-11.2
		c1-6.9,0.9-14.1,0.9-18.2C509.8,355,512,327.3,512,296.6z M86.2,145.2c4.8-11.2,19.2-33.7,26.2-37.7c1.7-1,16.6-5.7,53.9-8.2
		c34.3-2.3,72.2-3.2,89.8-3.2s55.5,0.9,89.8,3.2c37.2,2.5,52.3,7.1,53.9,8.2c9,6.2,21.4,26.5,26.2,37.7c4.8,11.2,11.2,33.2,10,36.2
		c-1.2,3,1.2,4.5-15,3.2c-16.1-1.2-117.2-2.5-164.8-2.5c-47.5,0-148.6,1.3-164.8,2.5c-16.2,1.2-13.8-0.2-15-3.2
		C75,178.4,81.4,156.5,86.2,145.2z M123,270.4c-7.2,1.8-11.5,5.7-20.5,5.6c-9,0-33.3-4.1-38.5-4.3c-5.2-0.2-9.8,3.5-12.5,4.2
		s-8-1.2-16-3.7s-12.7-1.8-15.3-12.7c-2.7-10.8,0-26.3,0-26.3c17.3-0.8,34,0.8,65.3,9.6c31.3,8.8,48.7,25.7,48.7,25.7
		S130.2,268.6,123,270.4z M358.2,349.2c-14.3,1.9-74.2,2.4-102.2,2.4c-28,0-87.9-0.6-102.2-2.4c-14.6-1.9-33.6-19.4-20.5-33.3
		c17.7-18.9,14.4-18.3,54.6-23.5c34.8-4.5,61.2-4.7,68.1-4.7c6.8,0,33.3,0.3,68.1,4.7c40.2,5.2,36.9,4.6,54.6,23.5
		C391.8,329.8,372.8,347.3,358.2,349.2z M491.8,259.6c-2.7,10.8-7.3,10.2-15.3,12.7s-13.3,4.3-16,3.7s-7.3-4.3-12.5-4.2
		c-5.2,0.2-29.5,4.3-38.5,4.3c-9,0-13.3-3.8-20.5-5.6c-7.2-1.8-11.2-1.8-11.2-1.8s17.3-17,48.7-25.7c31.3-8.8,48-10.4,65.3-9.6
		C491.8,233.2,494.5,248.7,491.8,259.6z"/>
</g>
</svg>
`,
      }}
    />
  )
}
